module.exports = "https://venezia-network.servercdn.it/static/img/story1.svg?8b1366c972471a3ff11e713f744ff0ac";